import { recoilPersist } from 'recoil-persist';

export const { persistAtom } = recoilPersist({
  key: 'gloo-app-v1.0.0',
  storage: localStorage,
});
